import moment from 'moment-timezone';

export const generateWithTimezone = (
  time: string,
  timezone?: string,
): moment.Moment => {
  if (!timezone && time.endsWith('23:59:59Z')) {
    return moment.utc(time);
  }

  if (timezone === 'browser_time') {
    return moment(time);
  }

  return moment(time).tz(timezone);
};

export const formatDateTime = (
  datetime: moment.Moment,
  format: string,
): string => {
  return datetime.format(format);
};

export const calculateDiffFromToday = (
  time: string,
  unitOfTime: moment.unitOfTime.Diff,
  precise = false,
): number => {
  return moment(time).diff(moment(), unitOfTime, precise);
};
